import React from 'react';

const RadioBoxIcon = ({ props }: { props: any }) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="5.62233"
      cy="5.37135"
      r="4.4846"
      stroke="#7A8CBC"
      strokeWidth="1.28131"
    />
    <circle cx="5.6222" cy="5.37122" r="2.56263" fill="#7A8CBC" />
  </svg>
);

export default RadioBoxIcon;
